<template>
  <div>
    <div class="text-right">
      <button v-if="!loading" @click="getPayments" class="btn btn-outline-info">Обновить оплаты</button>
    </div>
    <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
    <template v-if="records">
      <table class="table table-sm table-hover mt-0">
        <thead>
        <tr>
          <th>#</th>
          <th>id</th>
          <th>сумма</th>
          <th>агент</th>
          <th>комментарий</th>
          <th>дата</th>
          <th>инкассация</th>
          <th>курьер</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(g, i) in groups">
          <tr class="pointer" @click="showDetails(i)">
            <td colspan="10">
              <p>{{ printDate(Object.values(g)[0].records[0].pay_date) }}</p>
              <p v-for="(r, uId) in g"><strong>{{ r.total.toLocaleString('ru-RU') }}</strong> -
                {{ users[uId]?.name ?? uId }}
              </p>
            </td>
          </tr>
          <template v-if="displayDetails[i]">
            <template v-for="(gr, id) in g">
              <tr v-for="(r,ii) in gr.records">
                <td>{{ ii + 1 }}</td>
                <td>{{ r.id }}</td>
                <td>{{ r.sum.toLocaleString('ru-RU') }}</td>
                <td>{{ users[r.user_id]?.name }}</td>
                <td>{{ r.comment }}</td>
                <td>{{ printDate(r.pay_date) }}</td>
                <td>{{ (r.income?.sum ?? 0).toLocaleString('ru-RU') }}</td>
                <td>{{ r.income?.user?.name }}</td>
              </tr>
            </template>
          </template>
        </template>
        </tbody>
      </table>
    </template>
    <template v-if="!loading && !records">
      <h5>Выплаты не найдены</h5>
    </template>
  </div>
</template>

<script>

import api from "@/api";
import moment from "moment";

export default {
  props: ['agent'],
  data() {
    return {
      users: {
        290: {name: 'М'},
        291: {name: 'Брат М'},
        // 311: {name: 'Денис Тольятти'},
      },
      groups: null,
      displayDetails: {},
      loading: false,
      records: null,
    }
  },
  created() {
    this.getPayments();
  },
  methods: {
    showDetails(i) {
      console.log(i);
      this.displayDetails[i] = !this.displayDetails[i];
      this.displayDetails = {...this.displayDetails};
    },
    async getPayments() {
      this.loading = true;
      const {data} = await api.index('/users/agents/payments/' + (this.agent?.id ?? 0));
      if (data.success) {
        this.groups = data.records.reduce((acc, r) => {
          const index = moment(r.pay_date).format('X');
          if (!acc[index]) acc[index] = {};
          if (!acc[index][r.user_id]) acc[index][r.user_id] = {records: [], total: 0};
          acc[index][r.user_id].total += r.sum;
          acc[index][r.user_id].records.push(r);
          return acc;
        }, {})
        this.records = data.records;
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading = false;
    }
  }
}

</script>
